import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { FormListeners } from '../../../models/beans/form-listeners.abstract';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { setDatiBilancioBisDataChiusuraListeners } from './dati-bilancio-bis-data-chiusura.listeners';
import { setDatiBilancioBisDataApprovazioneListeners } from './dati-bilancio-bis-data-approvazione.listeners';

export class DatiBilancioBisFormListeners extends FormListeners {
    private readonly store: Store<Revisione53State>;

    constructor(form: FormGroup, store: Store<Revisione53State>) {
        super(form);
        this.store = store;
    }

    setListeners(): void {
        setDatiBilancioBisDataChiusuraListeners(this.form, this.store);
        setDatiBilancioBisDataApprovazioneListeners(this.form, this.store);
    }
}
